var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",attrs:{"id":"pm-ref-stats"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border-width":"0"},attrs:{"src":_vm.nationalStatsURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }